<template>
<ScreenLayout>

    <v-toolbar slot="header" dark class="primary">
        <!-- <v-btn @click.native="$router.push('/home')" icon>
            <v-icon>chevron_left</v-icon>
        </v-btn>         -->
        <v-toolbar-title>{{pageTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <span v-if="editing">Editing</span>
        <v-menu offset-y>
            <template v-slot:activator="{ on }">    
                <v-icon v-on="on">more_vert</v-icon>
            </template>
            <v-list>
                <v-list-item v-if="canWrite(policiesDoc)">
                    <v-list-item-title>
                        <v-switch v-model="editing" label="Edit Mode" class="ml-4"/>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="canWrite(policiesDoc)" @click="downloadBackups">
                    <v-list-item-title>Download Policy Backup</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="canWrite(policiesDoc) && editing && selectedRequirement" @click="addSpecialChecks('statements')">
                    <v-list-item-title>Add statement checks</v-list-item-title>
                </v-list-item>
                <v-list-item @click="startCreation()">
                    <v-list-item-title>Start Creation</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-toolbar>  


    <div slot="left" class="white-background" style="position:relative;display:flex;flex-direction:column;height:100%">
        <ListList v-model="lender" :items="lenders" @click="resetPolicy">
            <v-list-item slot="top" :input-value="false" @click="lender = null">
                <v-list-item-content>
                    <v-list-item-title>General Requirements</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="canWrite(lendersDoc) && editing" slot="bottom" :input-value="false" @click="addLender">
                <v-list-item-content>
                    <v-list-item-title>Add a Lender</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </ListList>
    </div>
        
    
    <div class="display-flex" style="margin-bottom:-10px">
        <v-text-field filled dense rounded placeholder="Search..." style="margin:6px 20px" v-model="search" hide-details @focus="$event.target.select()" />
        <!-- <v-switch v-if="canWrite(policiesDoc)" style="margin: 9px 20px -20px 0" v-model="editing" color="primary" label="Edit Mode" /> -->
    </div>
    
    <!-- Categories -->
    <template v-for="category in categories">
    <div v-if="filterPolicies(category.policies).length" :key="category.name" class="white ma-5 elevation-3" style="position:relative;padding: 60px 40px 20px 40px">

        <!-- Heading Bar -->
        <div style="font-weight:bold;position:absolute;top:0;left:0;right:0;font-size:16px;text-align:center;letter-spacing:3px;padding:8px;background-color:#eee;color:#888;text-transform:uppercase;">
            {{category.name}}
            <div style="float:right" v-if="editing">
                <v-menu offset-y left>
                    <template v-slot:activator="{ on }">
                        <v-icon color="grey" v-on="on">more_vert</v-icon>
                    </template>
                    <v-list>
                        <v-list-item @click="addPolicy(category)">
                            <v-list-item-title>Add another {{category.name}} policy</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>  
            </div>
        </div>

        <!-- Policies -->
        
        <div v-for="policy in filterPolicies(category.policies)" @click="selectedPolicy = policy" class="mb-6 policy-container" :key="policy._id">
            <div style="margin-bottom:0px;color:#666;font-weight:bold;">
                
                    <div @click="selectedRequirement = null" class="policy-box" style="display:inline">
                        <EditableText plain v-model="policy.name" :read-only="!editing" inline />
                    </div>
                    <div style="display:inline;margin-left:-6px" v-if="editing">
                        <v-menu offset-y left>
                            <template v-slot:activator="{ on }">
                                <v-icon color="grey lighten-2" v-on="on">more_vert</v-icon>
                            </template>
                            <v-list>
                                <v-list-item @click="addPolicy(category)">
                                    <v-list-item-title>Add another {{category.name}} policy</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="deletePolicy(policy, category)">
                                    <v-list-item-title>Delete policy</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="!policy._stipulation._default" @click="revertToGeneric(policy)">
                                    <v-list-item-title>Revert {{lender.name}} back to generic policy</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>  
                    </div>

            </div>

            <!-- Stipulation Options -->

            <template v-if="policy._stipulation">
                <div v-for="(option, optionIndex) in policy._stipulation.options" class="options-section" :class="{specific: !policy._stipulation._default}" :key="optionIndex">

                    <div style="font-size:14px;font-weight:bold;padding:3px;" v-if="optionIndex != 0">&nbsp;&nbsp;&nbsp;(OR)</div>
                    
                    <!-- Requirements -->

                    <div v-for="(requirement, requirementIndex) in option.requirements" style="display:inline" :key="requirementIndex">
                        <div style="display:inline;font-size:14px;font-weight:bold;padding:3px 0 3px 3px" v-if="requirementIndex != 0">AND</div>

                        <div style="display:inline;" class="hoverable requirement-box" :class="{hilight: isRequirementHilighted(requirement)}" @click="selectedRequirement = requirement">           
                            <EditableText v-model="requirement.description" @change="savePolicy(policy, $event)" :read-only="!editing" plain inline />
                        </div>

                        <div v-if="editing"  style="display:inline;margin: 0 -8px;">
                            <v-menu offset-y left>
                                <template v-slot:activator="{ on }">
                                    <v-icon color="grey lighten-2" v-on="on">more_vert</v-icon>
                                </template>
                                <v-list>
                                    <v-list-item @click="addRequirement(option)">
                                        <v-list-item-title>AND (another requirement)</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="addOption(policy)">
                                        <v-list-item-title>OR (alternative requirements)</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="option.requirements.length > 1" @click="deleteRequirement(requirement, option, policy)">
                                        <v-list-item-title>Delete Requirement</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="option.requirements.length == 1 && policy._stipulation.options.length > 1" @click="deleteOption(policy, optionIndex)">
                                        <v-list-item-title>Delete Entire Option</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="optionIndex" @click="makePreferredRequirement(option, policy)">
                                        <v-list-item-title>Make This the Preferred Option</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>  
                        </div>                        
                        
                    </div>

                </div>
            </template>
            <div v-if="lender && policy._stipulation._default" class="light-text small-text">
                * Not {{lender.name}} specific. 
                <a v-if="editing" href @click.prevent="makeLenderRequirements(policy)">Specify</a>
            </div>

        </div>

    </div>
    </template>

    <v-btn v-if="canWrite(policiesDoc)" @click="saveAll">Save</v-btn>

    <!-- Right Column -->

    <div slot="right" class="white-background pa-6 full-height" style="overflow-y:auto">
        
        <!-- Lender -->
        <template v-if="lender && !selectedPolicy">
            <FormControl v-if="editing" :value="lender" @input="updateLender" :schema="lenderSchema" />
            <FormControl v-if="!editing" :value="lender" @input="updateLender" :schema="lenderSchemaRO" />
        </template>

        <template v-if="selectedPolicy">
            <FormControl :value="selectedPolicy" @input="updatePolicy" :schema="policySchema" />
        </template>

        <!-- Stipulation -->
        <template v-if="selectedPolicy && !selectedPolicy._stipulation._default">
            <FormControl :value="selectedPolicy._stipulation" @input="updateStipulation" :schema="stipulationSchema" />
        </template>
       
        <template v-if="selectedRequirement">
            <div class="section-heading mb-3">Requirement</div>
            <FormControl :value="selectedRequirement" @input="updateRequirement" :schema="requirementSchema" />
        </template>

        <template v-if="editing">
            <Permissions :document="policiesDoc" />
            <Permissions :document="lenderStipulationsDoc" @change="saveLenderStipulations" label="Lender Permissions" />
        </template>


    </div>

</ScreenLayout>
</template>

<script>
import ScreenLayout from '@/screens/ScreenLayout'
import Db from '@/data/Db'
import Db1 from '@/data/Db1'
import ConfirmIcon from '@/ui-elements/ConfirmIcon'
import ListList from '@/forms/lists/ListList'
import RouterHelpers from '@/helpers/RouterHelpers'
import FormControl from '../forms/FormControl'
import EditableText from '../ui-elements/EditableText'
import ArrayHelpers from '../helpers/ArrayHelpers'
import Utilities from '../helpers/Utilities'
import FileHelpers from '../helpers/FileHelpers'
import Permissions from '../forms/Permissions'
import Security from '../data/Security'
import OrderHelpers from '../helpers/OrderHelpers'
import AlertHelpers from '../helpers/AlertHelpers'

export default {
    name: 'Policies',
    props: {
        i: String, //id of selected item
    },
    components: {
        ScreenLayout, ConfirmIcon, ListList, FormControl, EditableText, Permissions
    },
    data() {
        return {
            showingGuide: false,
            search: null,   
            lender: null,
            editing: false,
            selectedRequirement: null,
            selectedPolicy: null,
            policiesDoc: null,
            proofsDoc: null,
            lendersDoc: null,
            lenderStipulationsDoc: null,

            newLenderSchema: {
                width:360,
                fields: [
                    {
                        name: 'name',
                        type: 'Text',
                        label: 'Lender Name'
                    }
                ]
            },

            item: null,

            lenderSchema: {
                readOnly: true,
                fields: [
                    {
                        visible: '[editing]',
                        type: 'Section Heading',
                        label: '[name]'
                    },                
                    {
                        visible: '[editing]',
                        name: 'name',
                        type: 'Text',
                        label: 'Lender Name'
                    },                
                    {
                        name: 'checklist',
                        type: 'File',
                        multiple: true,
                        label: 'Lender Issued Checklist'
                    },                
                ]                
            },

            lenderSchemaRO: {
                readOnly: true,
                fields: [            
                    {
                        name: 'checklist',
                        type: 'File',
                        multiple: true,
                        label: 'Lender Issued Checklist'
                    },                
                ]                
            },

            stipulationSchema: {
                readOnly: true,
                fields: [
                    {
                        name: 'notRequired',
                        type: 'Checkbox',
                        label: 'Evidence Not Required'
                    },
                    {
                        name: 'notSupported',
                        type: 'Checkbox',
                        label: 'Policy Not Supported'
                    },                    
                ]
            },

            policySchema: {
                readOnly: true,
                fields: [
                    {
                        type: 'Section Heading',
                        label: '[name]'
                    },                
                    {
                        name: 'keywords',
                        type: 'Text',
                        label: 'Keywords for Searching'
                    },  
                    {
                        name: 'checklistField',
                        type: 'Text',
                        label: 'Checklist Field'
                    },                             
                ]
            },

            requirementSchema: {
                readOnly: true,
                fields: [
                    {
                        name: 'description',
                        type: 'Text',
                        label: 'Description'
                    },
                    {
                        name: 'checks',
                        type: 'Group',
                        label: 'Checks',
                        fields: [
                            {
                                name: 'description',
                                type: 'Text',
                                label: 'What to Check'
                            },
                            {
                                name: 'officeUseOnly',
                                type: 'Checkbox',
                                label: 'Office Use Only'
                            },
                        ]
                    },
                    {
                        name: 'details',
                        type: 'Html',
                        label: 'Details'
                    },                    
                    {
                        name: 'sample',
                        type: 'File',
                        label: 'Sample'
                    },
                    {
                        name: 'template',
                        type: 'File',
                        multiple: true,
                        label: 'Template'
                    },
                    {
                        name: 'expiryDays',
                        type: 'Number',
                        label: 'Days to Expiry'
                    },
                    {
                        name: 'officeUseOnly',
                        type: 'Checkbox',
                        label: 'Office Use Only'
                    },

                ]
            },

            
        }
    },
    computed:{

        pageTitle() {
            return (this.lender ? this.lender.name + ' ' : '') + ' Evidence Requirements'
        },
        categories() {
            if(!this.policiesDoc)
                return []
            return this.policiesDoc.categories
        },
        lenders() {
            if(!this.lendersDoc)
                return []
            if(!this.lendersDoc.list)
                this.lendersDoc.list = []
            return this.lendersDoc.list
        }, 
        proofs() {
            if(!this.proofsDoc)
                return []
            if(!this.proofsDoc.list)
                this.proofsDoc.list = []
            return this.proofsDoc.list
        }, 
        proofsSelect() {
            return this.proofs.map(o => {
                return {
                    value: o._id,
                    text: o.title
                }
            })
        },

        lenderName() {
            if(this.lender)
                return this.lender.name
            return null
        },

        allPolicies() {
            return this.getAllPolicies(this.policiesDoc)
        },      
    },
    methods: {
        getAllPolicies(doc) {
            if(!doc)
                return []

            const policies = []
            doc.categories.forEach(cat => {
                if(cat.policies) {
                    cat.policies.forEach(pol => {
                        policies.push(pol)
                    })
                }
            }) 
            return policies  
        },
        canWrite(doc) {
            return Security.canWrite(doc)
        },
        filterPolicies(policies) {
            if(this.search)
                return policies.filter(o => 
                    (o.name && 
                    o.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1) ||
                    (o.keywords && 
                    o.keywords.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                )
            else
                return policies
        },
        savePolicy(policy) {
            console.log('savePolicy')
            const newStipulation = JSON.parse(JSON.stringify(policy._stipulation))
            delete newStipulation._default
            if(policy._stipulation._default) {
                delete newStipulation._id
                policy.default = newStipulation
                this.savePolicies()
            }
            else {
                this.updateCollection(newStipulation, this.lenderStipulationsDoc.stipulations)
                this.saveLenderStipulations()
            }
        },

        updateCollection(obj, arr) {
            let idx = arr.findIndex(o => o._id == obj._id)
            if(idx >= 0) {
                this.$set(arr, idx, obj)
                return true
            } else
                return false        
        },

        makePreferredRequirement(option, policy) {
            const idx = policy._stipulation.options.findIndex(o => o == option)
            ArrayHelpers.moveItem(policy._stipulation.options, idx, 0)
        },

        addPolicy(category) {
            if(!category.policies)
                this.$set(category, 'policies', [])

            const stipulation = {
                options: [
                        {
                            requirements: [
                                {description: 'New requirement...'}
                            ]
                        },
                    ]
            } 
            category.policies.push({
                'name': 'New policy...', 
                '_id': Db1.newId(),
                'default': {...stipulation},
                '_stipulation': {...stipulation, _default: true},
            })
        },

        addRequirement(option) {
            option.requirements.push({description: 'Requirement ' + (option.requirements.length + 1) + '...'})
        },

        addOption(policy) {
            policy._stipulation.options.push({
                requirements: [
                    {description: 'Requirement 1...'}
                ]
            })
        },

        deleteRequirement(requirement, option, policy) {
            const idx = option.requirements.findIndex(o => o == requirement)
                if(idx) {
                    option.requirements.splice(idx, 1)       
                    this.savePolicy(policy)     
                }
        },

        deleteOption(policy, optionIndex) {
            policy._stipulation.options.splice(optionIndex, 1)
            this.savePolicy(policy)
        },

        async deletePolicy(policy, category) {
            if(await this.$root.$confirm('Delete', 'Are you sure you want to delete this policy and associated requirements?', { color: 'red' }) == true) {
                const idx = category.policies.findIndex(o => o == policy)
                if(idx)
                    category.policies.splice(idx, 1)
            }

        },

        saveAll() {
            this.savePolicies()
            this.saveLenders()
        },

        savePolicies() {
            const doc = JSON.parse(JSON.stringify(this.policiesDoc))
            const policies = this.getAllPolicies(doc)
            policies.forEach(policy => {
                delete policy._stipulation
                //delete policy._default
            })
            Db1.saveDocument(doc)
        },

        saveLenders() {
            this.lendersDoc.list = this.lendersDoc.list.sort(OrderHelpers.sortByName)
            Db1.saveDocument(this.lendersDoc)
        },

        updateLender(lender) {
            //rather than v-model so we don't lose the referenct back to the original requirement...
            //using copyProperties to give a reactive version of object assign.
            Utilities.copyProperties(lender, this.lender)
            this.saveLenders()
        },

        updateRequirement(requirement) {
            //rather than v-model so we don't lose the referenct back to the original requirement...
            //using copyProperties to give a reactive version of object assign.
            Utilities.copyProperties(requirement, this.selectedRequirement)
            this.savePolicy(this.selectedPolicy)
        },

        updatePolicy(policy) {
            //rather than v-model so we don't lose the referenct back to the original requirement...
            //using copyProperties to give a reactive version of object assign.
            Utilities.copyProperties(policy, this.selectedPolicy)
            this.savePolicy(this.selectedPolicy)
        },

        updateStipulation(stipulation) {
            //rather than v-model so we don't lose the referenct back to the original requirement...
            //using copyProperties to give a reactive version of object assign.
            Utilities.copyProperties(stipulation, this.selectedPolicy._stipulation)
            this.savePolicy(this.selectedPolicy)
        },

        markupSchema(schema) {

        },
        
        downloadBackups() {
            FileHelpers.downloadObject(this.policiesDoc, 'Policies')
        },

        async addLender() {
            const newLender = { 
                _id: Db1.newId(),
                name: null,
            }
            const lender = await this.$root.$dialog(newLender, this.newLenderSchema)
            if(lender)
                this.lenders.unshift(lender)
        },
        resetPolicy() {
            this.lenderStipulationsDoc = null
            this.selectedPolicy = null
            this.selectedRequirement = null
        },

        lenderChanged() {
            
            //reset all stipulations to default
            this.allPolicies.forEach(policy => {
                this.setStipulation(policy)
                // const req = JSON.parse(JSON.stringify(policy.default))
                // this.$set(policy, '_stipulation', {...req, _default:true})
            })
            
            if(!this.lender) {
                RouterHelpers.setQueryParameter(this, 'l', null)
                return
            }

            RouterHelpers.setQueryParameter(this, 'l', this.lender._id)
                

            //overrride the lender ones...

            Db1.fetchDocument('apps/dc/stipulations', this.lender._id).then(doc => {
                this.lenderStipulationsDoc = doc || 
                {
                    _id: this.lender._id,
                    _path: 'apps/dc/stipulations',
                    lender: this.lender.name,
                    stipulations: [],
                }
                
                this.lenderStipulationsDoc.stipulations.forEach(stipulation => {
                    const idx = this.allPolicies.findIndex(p => p._id == stipulation._id)
                    if(idx >= 0) {
                        this.setStipulation(this.allPolicies[idx], stipulation)
                        // const newStipulation = JSON.parse(JSON.stringify(stipulation))
                        // newStipulation._default = false
                        // this.allPolicies[idx]._stipulation = newStipulation
                    }
                })
            }).catch(err => {
                console.log('lenderChanged', err)
            })
            
            this.selectedRequirement = null
        },

        makeLenderRequirements(policy) {
            const lenderPolicy = JSON.parse(JSON.stringify(policy.default))
            lenderPolicy._id = policy._id

            this.setStipulation(policy, lenderPolicy)
            // lenderPolicy._default = false
            // this.$set(policy, '_stipulation', lenderPolicy)
            this.lenderStipulationsDoc.stipulations.push(lenderPolicy)
        },

        saveLenderStipulations() {
            Db1.saveDocument(this.lenderStipulationsDoc)
        },

        revertToGeneric(policy) {
            console.log('reverting')
            this.setStipulation(policy)
            const idx = this.lenderStipulationsDoc.stipulations.findIndex(o => o._id == policy._id)
            if(idx > -1) {
                this.lenderStipulationsDoc.stipulations.splice(idx, 1)
                this.saveLenderStipulations()
            }
            this.savePolicy(policy)
        },

        setStipulation(policy, stipulation) {
            const newStipulation = JSON.parse(JSON.stringify(stipulation || policy.default))
            newStipulation._default = !Boolean( stipulation )
            this.$set(policy, '_stipulation', newStipulation)
        },

        addSpecialChecks(type) {
            if(!this.selectedRequirement.checks)
                this.$set(this.selectedRequirement, 'checks', [])
            if(type == 'statements') {
                this.selectedRequirement.checks.push({description: 'Name is shown to identify statements'})
                this.selectedRequirement.checks.push({description: 'Entire duration shown with no gaps'})
                this.selectedRequirement.checks.push({description: 'May include transaction listings, but must contain 1 real proper statement'})
                this.selectedRequirement.checks.push({description: 'No overdue/overlimit/negative balances'})
                this.selectedRequirement.checks.push({description: 'No defaults, penalties or arrears in transactions'})
                this.savePolicy(this.selectedPolicy)
            }
        },

        isRequirementHilighted(requirement) {
            
            if(!this.editing)
                return (requirement == this.selectedRequirement)
        },
        startCreation() {
            const documents = []
            let categoryOrder = 0
            this.policiesDoc.categories.forEach(category => {
                categoryOrder += 1
                category.policies.forEach(policy => {
                    policy.default.options.forEach(option => {
                        option.requirements.forEach(requirement => {
                            const req = {...requirement}
                            req.category = category.name
                            req.order = categoryOrder
                            req.for = policy.name
                            documents.push(req)
                        })
                    })
                })
            })
            console.log(documents)
            const documentsDoc = {
                _id: Db1.newId(),
                _path: '/apps/dc/lists',
                code:'documents',
                documents: documents,
                permissions: {
                    editors: [
                        Security.getMyId()
                    ]
                }
            }
            debugger
            Db1.saveDocument(documentsDoc)
        }
    },

    created() {    

        this.markupSchema(this.policySchema)

        Db1.fetchDocumentByCode('apps/dc/lists', 'policies').then(doc => {
            this.policiesDoc = doc

            //load default values into requirements...
            this.allPolicies.forEach(policy => {
                this.setStipulation(policy)
            })
        })
        
        Db1.fetchDocumentByCode('apps/dc/lists', 'lenders').then(doc => {
            this.lendersDoc = doc
            const lenderId = this.$route.query.l
            if(lenderId) {
                
                const idx = this.lenders.findIndex(o => o._id == lenderId)
                if(idx > -1)
                    this.$set(this, 'lender', this.lenders[idx])
            }

        })        
    },

    watch: {
        'lender': {
             handler: function(newVal) {
                console.log('detected lender change')
                this.lenderChanged()
            }           
        },

        'editing': {
            handler: function(newVal) {
                this.requirementSchema.readOnly = !newVal
                this.policySchema.readOnly = !newVal
                this.lenderSchema.readOnly = !newVal
                this.stipulationSchema.readOnly = !newVal
            }
        }
    },

    beforeDestroy() {

    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.options-section {
    color:#777;font-weight:300
}

.options-section.specific {
    color: rgb(11, 103, 179) 
}

.policy-container {
    font-size: 18px;
}

.policy-box {
    border-radius: 2px;
}

.requirement-box {
    border-radius: 2px;
    position:relative;
}

.requirement-box.hilight {
    background-color: rgba(252, 252, 46, 0.61);
    box-shadow: 0px 0px 0px 3px rgba(252, 252, 46, 0.61);
}

.policy-box:hover {
    /* background-color:  0px 0px 0px 5px rgba(0,0,0,0.01);
    box-shadow: 0px 0px 0px 5px rgba(0,0,0,0.01); */
}

.requirement-box:hover {
    box-shadow: 0px 0px 0px 3px rgba(0,0,0,0.05);
}

</style>


// WEBPACK FOOTER //
// Policies.vue?5b7c3972